var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3939 0C33.6575 0 20.0908 13.5667 20.0908 30.303V60.6061H32.212V30.303C32.212 20.2636 40.3514 12.1212 50.3939 12.1212C60.4363 12.1212 68.5757 20.2636 68.5757 30.303V60.6061H80.6969V30.303C80.6969 13.5667 67.1302 0 50.3939 0Z",
    fill: "#D1D1DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7879 87.8788C89.7879 94.5727 84.3606 100 77.6667 100H23.1212C16.4273 100 11 94.5727 11 87.8788V51.5151C11 44.8212 16.4273 39.3939 23.1212 39.3939H77.6667C84.3606 39.3939 89.7879 44.8212 89.7879 51.5151V87.8788Z",
    fill: "#F2F2F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2d89336126f43dd9622c4940e6c182fd.svg";
export { ForwardRef as ReactComponent };